import { Component, OnInit } from '@angular/core';
import { JhiLanguageService } from '../../shared/core-utils';
import { VariableDetails } from '../../shared/ontology/model/variable-details';
import { VariableDetailsContext } from './variable-details.context';
import { VariableType } from '../../shared/ontology/model/variable-type';

@Component({
    selector: 'jhi-details',
    templateUrl: './details.component.html',
})
export class DetailsComponent implements OnInit {

    variableDetails: VariableDetails;

    constructor(private languageService: JhiLanguageService,
                private variableDetailsContext: VariableDetailsContext) {

    }

    ngOnInit(): void {
        const currentLang = this.languageService.getCurrentLanguage();
        this.languageService.changeLanguage(currentLang);
        this.variableDetailsContext.variableDetails.subscribe((variableDetails: VariableDetails) => this.variableDetails = variableDetails);
    }

    formatRoles(): string {
        if (this.variableDetails && this.variableDetails.variableTypes) {
            return this.variableDetails.variableTypes.map((value: VariableType) => value.name).join(', ' );
        }
        return '';
    }

    formatCropOntologyURL(): string {
        if (this.variableDetails && this.variableDetails.property) {
            return `http://www.cropontology.org/term/${this.variableDetails.property.cropOntologyId}`;
        }
        return '';
    }

}
